import { render, staticRenderFns } from "./ArchiveDiscards.vue?vue&type=template&id=6f2178d0&"
import script from "./ArchiveDiscards.vue?vue&type=script&lang=js&"
export * from "./ArchiveDiscards.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDiscards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveDiscards.vue"
export default component.exports